<template>
	<div>
		<TilteParallax
			v-if="$vuetify.breakpoint.mdAndUp"
			image="https://apps.pinturasacuario.mx/assets/store/images/customer/search.jpg"
		>
			<template v-slot:title v-if="criterion">
				Resultados de la busqueda
			</template>

			<template v-slot:title v-else>
				¿No sabe por donde empezar?
			</template>

			<template v-slot:subtitle>
				<template v-if="criterion">
					{{ `${results.length} resultados sobre: "${criterion}"` }}
				</template>

				<template v-else>
					Conozca la gran variedad de productos que Pinturas Acuario
					tiene para usted.
				</template>
			</template>
		</TilteParallax>

		<v-container fluid class="pt-0">
			<v-row class="bar-for-mobile" v-if="$vuetify.breakpoint.smAndDown">
				<v-col cols="4" class="pa-0">
					<div class="option">
						<v-icon class="mr-1">mdi-swap-vertical</v-icon>
						Ordenar
					</div>
				</v-col>
				<v-col cols="4" class="pa-0">
					<div
						@click="viewToggle()"
						class="option option-with-divider"
					>
						<v-icon class="mr-1">
							{{ viewActive.icon }}
						</v-icon>
						{{ viewActive.name }}
					</div>
				</v-col>
				<v-col cols="4" class="pa-0">
					<div
						@click="ui.showOverlayFilterPanel = true"
						class="option option-with-divider"
					>
						<v-badge
							:color="
								ui.filtersActive.length
									? 'orange'
									: 'transparent'
							"
							:content="ui.filtersActive.length"
							v-if="$vuetify.breakpoint.smAndDown"
						>
							<div class="d-flex align-center">
								<v-icon class="mr-1">mdi-filter</v-icon>
								Filtros
							</div>
						</v-badge>
					</div>
				</v-col>
			</v-row>

			<v-row justify="center">
				<v-col
					cols="12"
					md="11"
					lg="10"
					:class="[{ 'mt-9': $vuetify.breakpoint.smAndDown }]"
				>
					<v-card
						:flat="$vuetify.breakpoint.smAndDown"
						:outlined="$vuetify.breakpoint.mdAndUp"
					>
						<v-card-text
							:class="[
								'pt-0',
								{ 'pa-0': $vuetify.breakpoint.smAndDown },
							]"
						>
							<v-container fluid>
								<v-row>
									<v-col
										cols="12"
										md="4"
										lg="3"
										class="d-flex flex-column"
										v-if="$vuetify.breakpoint.mdAndUp"
									>
										<!-- Filter Panel Component -->
										<FilterPanel
											@filtersActive="setFiltersActive"
										></FilterPanel>
									</v-col>

									<v-col cols="12" md="8" lg="9" class="pa-1">
										<v-row
											align="stretch"
											class="products-container"
										>
											<template
												v-if="filteredResults.length"
											>
												<v-col
													v-for="item in resultsChunk[
														ui.page
													]"
													cols="6"
													sm="6"
													lg="4"
													class="pa-0 d-flex align-center justify-center animate__animated animate__fadeIn animate__faster"
													style="height: 350px;"
												>
													<!-- Product Component -->
													<Product
														:product="item"
													></Product>
												</v-col>
											</template>

											<template v-else>
												<v-col
													cols="12"
													class="d-flex justify-center"
												>
													<h2
														class="noresults-message animate__animated animate__tada animate__fast"
													>
														Sin resultados
													</h2>
												</v-col>
											</template>
										</v-row>

										<v-row v-if="filteredResults.length">
											<v-col
												cols="12"
												:class="[
													'd-flex',
													$vuetify.breakpoint
														.smAndDown
														? 'justify-center'
														: 'justify-end',
												]"
											>
												<v-pagination
													:length="
														resultsChunk.length - 1
													"
													v-model="ui.page"
													:total-visible="5"
													@input="scrollToTop()"
												></v-pagination>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- Filter Panel Component -->
		<template v-if="$vuetify.breakpoint.smAndDown">
			<Overlay v-model="ui.showOverlayFilterPanel">
				<template v-slot:title>
					Filtros
				</template>

				<template v-slot:subtitle>
					Filtros activos:
					{{ ui.filtersActive.length }}
				</template>

				<template v-slot:content>
					<!-- Filter Panel Component -->
					<FilterPanel
						@filtersActive="setFiltersActive"
					></FilterPanel>
				</template>
			</Overlay>
		</template>

		<v-btn
			fab
			dark
			color="orange"
			@click="scrollToTop()"
			:class="[
				'btn-up',
				'elevation-7',
				'animate__faster',
				'animate__animated',
				ui.showButtonToTop
					? 'animate__fadeInUp'
					: 'animate__fadeOutDown',
			]"
		>
			<v-icon>
				mdi-chevron-up
			</v-icon>
		</v-btn>
	</div>
</template>

<script>
import Sort from "@/clas/Sort";
import { mapState } from "vuex";
import { EventBus } from "@/main";
import Overlay from "@/components/Overlay";
import FilterPanel from "@/components/FilterPanel";
import Product from "@/components/Product/Product";
import TilteParallax from "@/components/TilteParallax";

export default {
	components: { TilteParallax, FilterPanel, Overlay, Product },

	data() {
		return {
			resultsChunk: [],

			ui: {
				views: [
					{
						name: "Mosaico",
						icon: "mdi-view-dashboard",
						active: true,
					},

					{ name: "Lista", icon: "mdi-view-day", active: false },
				],
				page: 1,
				criterion: null,
				filtersActive: [],
				resultsCounter: false,
				showButtonToTop: false,
				headerCardFixed: false,
				showOverlayFilterPanel: false,
			},
		};
	},

	created() {
		this.$store.dispatch("getCategories");

		document.addEventListener("scroll", () => {
			if (window.scrollY >= 187) {
				this.ui.headerCardFixed = true;
			} else {
				this.ui.headerCardFixed = false;
			}

			if (window.scrollY > 350) {
				this.ui.showButtonToTop = true;
			} else {
				this.ui.showButtonToTop = false;
			}
		});
	},

	methods: {
		sliceIntoChunks(arr, chunkSize) {
			const res = [{}];

			for (let i = 0; i < arr.length; i += chunkSize) {
				const chunk = arr.slice(i, i + chunkSize);
				res.push(chunk);
			}

			return res;
		},

		setFiltersActive(filtersActive) {
			this.ui.page = 1;

			this.ui.filtersActive = filtersActive;
		},

		scrollToTop() {
			setTimeout(() => {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}, 200);
		},

		viewToggle() {
			let index = this.ui.views.indexOf(this.viewActive);

			index = index + 1;

			if (index >= this.ui.views.length) {
				index = 0;
			}

			this.ui.views = this.ui.views.map((item, key) => {
				item.active = key === index;

				return item;
			});
		},
	},

	computed: {
		...mapState({
			criterion: (state) => state.criterion,

			results: (state) => state.results,

			articles: (state) => state.articles,

			filters: (state) => state.filters,

			products: (state) => state.products,
		}),

		viewActive() {
			return this.ui.views.find((item) => item.active === true);
		},

		filteredResults() {
			let results_filtered = this.products;

			// Category
			if (this.filters.category) {
				if (this.filters.category.length) {
					results_filtered = results_filtered.filter((item) =>
						this.filters.category.includes(item.category_id)
					);
				}
			}

			// SortByName
			let sort = new Sort(results_filtered);
			results_filtered = sort.descByAtribute("name");

			this.resultsChunk = this.sliceIntoChunks(
				results_filtered,
				this.$vuetify.breakpoint.smAndDown ? 10 : 9
			);

			this.ui.page = 1;

			return results_filtered;
		},
	},
};
</script>

<style lang="css" scoped>
.btn-up {
	position: fixed;
	right: 35px;
	bottom: 25px;
	z-index: 20;
}

.noresults-message {
	top: 45%;
	position: fixed;
	display: flex;
	/*color: #015eb9;*/
	justify-content: center;
}

.header-card-fiexd {
	top: 90px;
	z-index: 1;
	width: 100%;
	position: fixed;
	background-color: #fff;
	border-bottom: 1px solid #ddd;
}

.bar-for-mobile {
	width: 100%;
	z-index: 10;
	position: fixed;
	cursor: pointer;
	background-color: #fff;
	border-bottom: 1px solid #ddd;
}

.bar-for-mobile * {
	color: #1976d2;
	font-size: 1rem;
}

.bar-for-mobile .option {
	height: 55px;
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;
}

.bar-for-mobile .option-with-divider::after {
	content: "";
	left: 0;
	top: 15px;
	height: 25px;
	position: absolute;
	border-left: 1px solid #bbb;
}

.products-container {
	/*height: 1100px;*/
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 600px) {
	.noresults-message {
		height: calc(100vh - 150px);
		align-items: center;
		position: relative;
	}
}

/*Small	sm	Small to medium tablet	600px > < 960px*/
@media (min-width: 601px) and (max-width: 960px) {
	.noresults-message {
		position: relative;
	}
}
</style>
